import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';

export const COLUMNS = (t) => [
    {
        label: t('search.directories_details.directory_table.first_directory'),
        key: 'first_directory',
        data: 'first_directory',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{data}</strong>;
        },
    },
    {
        label: t('search.directories_details.directory_table.subdomain'),
        key: 'subdomain',
        data: 'subdomain',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{data}</strong>;
        },
    },
    {
        label: t('search.directories_details.directory_table.week'),
        key: 'week',
        data: 'week',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{data}</strong>;
        },
    },
    {
        label: t('search.directories_details.directory_table.avg_weekly_urls'),
        key: 'urls',
        data: 'urls',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.directories_details.directory_table.avg_weekly_keywords'),
        key: 'keywords',
        data: 'keywords',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.directories_details.directory_table.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.directories_details.directory_table.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.directories_details.directory_table.avg_position'),
        key: 'position',
        data: 'position',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.directories_details.directory_table.ctr'),
        key: 'ctr',
        data: 'ctr',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div>
                    <strong>{numeral(data).format('0.00%')}</strong>
                </div>
            );
        },
    },
];

export const chartKeys = (t) => [
    {
        key: 'clicks',
        label: t('search.directories_details.directory_detail.clicks'),
        icon: 'clicks',
    },
    {
        key: 'impressions',
        label: t('search.directories_details.directory_detail.impressions'),
        icon: 'search',
    },
    {
        key: 'position',
        label: t('search.directories_details.directory_detail.position'),
        icon: 'pagev-view',
        yAxisID: 'y1',
        hidden: true,
    },
    {
        key: 'ctr',
        label: t('search.directories_details.directory_detail.ctr'),
        format: '0.00%',
        yAxisID: 'y1',
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'ctr',
        hidden: true,
    },
    {
        key: 'urls',
        label: t('search.directories_details.directory_detail.urls'),
        icon: 'pagev-view',
        yAxisID: 'y1',
        type: 'bar',
    },
    {
        key: 'keywords',
        label: t('search.directories_details.directory_detail.keywords'),
        icon: 'pagev-view',
        yAxisID: 'y1',
        type: 'bar',
    },
];
